import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "AI_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#AI_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#2E42A5"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "AI_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#AI_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.943 11.856l.004.35c.027 2.95.135 4.88.329 5.805.16.768.745 2.04 1.433 3.061.864 1.284 1.786 2.065 2.668 2.065.886 0 1.809-.727 2.67-1.936.706-.993 1.31-2.253 1.552-3.18.298-1.15.436-3.086.42-5.818l-.002-.348-.318.165c-.641.332-1.33.497-2.073.497-.734 0-1.441-.22-2.128-.661l-.118-.076-.12.074c-.724.444-1.405.663-2.043.663-.646 0-1.296-.165-1.952-.498l-.322-.163zm.546 6.113c-.19-.907-.298-2.828-.325-5.765.686.349 1.37.523 2.053.523.683 0 1.403-.232 2.16-.697.722.465 1.471.697 2.249.697s1.503-.174 2.175-.523c.017 2.716-.12 4.638-.413 5.765-.44 1.691-2.28 4.958-4.01 4.958-1.732 0-3.604-3.598-3.89-4.958z",
      fill: "#FBE625"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.164 12.204s.04 4.405.325 5.765c.285 1.36 2.157 4.958 3.889 4.958 1.73 0 3.571-3.267 4.01-4.958.439-1.691.414-5.765.414-5.765s-1.01.523-2.176.523c-1.166 0-2.248-.697-2.248-.697s-1.136.697-2.16.697c-1.025 0-2.054-.523-2.054-.523z",
      fill: "#F5FBFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "AI_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 21,
      y: 12,
      width: 9,
      height: 11
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.164 12.204s.04 4.405.325 5.765c.285 1.36 2.157 4.958 3.889 4.958 1.73 0 3.571-3.267 4.01-4.958.439-1.691.414-5.765.414-5.765s-1.01.523-2.176.523c-1.166 0-2.248-.697-2.248-.697s-1.136.697-2.16.697c-1.025 0-2.054-.523-2.054-.523z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#AI_svg__c)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M24.641 15.488c0 .288-.411 1.125-.65 1.34-.175.158-.121-.21-.08-.482.013-.096.026-.18.026-.224v-.02a.64.64 0 00-.006-.117c-.007-.035-.022-.07-.055-.144l-.045-.104c-.381-.813-.111-1.203.009-1.376a.588.588 0 00.041-.065c.018-.037.053-.07.09-.106.096-.093.217-.21.172-.47-.064-.366.322-.834.322-.834s-.094.908.35.686c.289-.145.811.063 1.276.247.25.1.484.192.655.22a.77.77 0 00.653-.18c.048-.037.085-.065.114-.065.102 0 .222.02.222.095 0 .074-.455.291-.684.36-.173.05.004.191.152.309.05.039.095.075.124.104.118.121.226.78-.047.365-.274-.414-.856-.69-1.351-.731-.495-.04-1.119.335-1.194.731-.075.397.585.324.585.324s-.048.062-.26.137c-.214.075-.419 0-.419 0zm-.498-.03a.107.107 0 01-.109.104.107.107 0 01-.108-.105c0-.058.048-.105.108-.105s.11.047.11.105zm2.44 1.943c-.303-.105-1.235-.058-1.486.081 0 0-.034-.216-.203-.365-.17-.15-.247-.163-.247-.163s.384.543.001.67c-.383.126-1.014-.237-1.219-.69-.204-.453-.244-1.096-.015-1.536.23-.44-.293-.026-.342.136-.011.04-.021.097-.031.158-.032.187-.069.41-.197.284-.17-.167-.581-.46-.646-.424-.065.036-.025.15.024.24.015.025.057.044.113.068.135.059.354.154.473.484.06.163.091.412.126.68.064.495.136 1.053.402 1.235.41.28-.43.639-.43.639s.597.11.885-.122c.207-.167.367-.118.494-.079.05.016.096.03.137.028.019-.001.045.002.077.005.21.02.681.068 1.208-.66l.069-.09a.722.722 0 01.1-.118.635.635 0 01.1-.061l.016-.01c.04-.021.119-.051.209-.085.257-.097.606-.228.382-.305zm-1.253.48a.107.107 0 01.144.044.107.107 0 01-.039.146.107.107 0 01-.144-.044.107.107 0 01.039-.146zm.512-3.007c.078.31.624 1.067.878 1.202 0 0-.163.146-.196.37-.034.223-.002.294-.002.294s.246-.617.56-.365c.316.253.354.98.086 1.398-.268.418-.786.802-1.28.849-.494.047.138.26.3.213.04-.012.094-.035.15-.06.174-.075.382-.166.346.01-.048.235-.07.739-.004.774.065.034.14-.062.187-.152.014-.026.007-.07-.003-.131-.025-.146-.064-.381.147-.66.105-.139.297-.302.502-.476.381-.324.81-.688.817-1.01.012-.497.77.012.77.012s-.232-.56-.584-.676c-.252-.082-.298-.244-.335-.371-.015-.051-.028-.097-.051-.13-.012-.015-.023-.039-.038-.067-.097-.187-.314-.609-1.212-.654a9.363 9.363 0 00-.113-.009.72.72 0 01-.153-.02c-.029-.008-.056-.023-.105-.05l-.018-.009a2.025 2.025 0 01-.185-.128c-.221-.163-.521-.384-.464-.154zm1.12.83a.107.107 0 01-.042-.146.107.107 0 01.144-.047c.05.028.07.093.041.146a.107.107 0 01-.143.046z",
      fill: "#FF9800"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M21.426 19.752h7.279v3.457h-7.28v-3.457z", fill: "#36C6FF" })), /* @__PURE__ */ e.createElement("path", { fill: "#2B409A", d: "M0 0h18v14H0z" }), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "AI_svg__d",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 18,
      height: 14
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h18v14H0z" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#AI_svg__d)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-2.006 13l3.961 1.737L18.088 1.89l2.09-2.582-4.236-.58-6.58 5.537-5.297 3.73L-2.005 13z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-1.463 14.216l2.018 1.009L19.428-.933h-2.833l-18.058 15.15z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M20.004 13l-3.961 1.737L-.09 1.89-2.18-.693l4.236-.58 6.58 5.537 5.297 3.73L20.003 13z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.87 13.874l-2.019 1.008-8.036-6.918-2.383-.773L-2.38-.684H.453l9.807 7.688 2.605.927 7.004 5.943z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "AI_svg__e",
      maskUnits: "userSpaceOnUse",
      x: -2,
      y: -2,
      width: 22,
      height: 18,
      fill: "#000"
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M-2-2h22v18H-2z" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.985 0h-2v6H0v2h7.985v6h2V8H18V6H9.985V0z"
      }
    )
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.985 0h-2v6H0v2h7.985v6h2V8H18V6H9.985V0z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.985 0v-1.5h-1.5V0h1.5zm2 0h1.5v-1.5h-1.5V0zm-2 6v1.5h1.5V6h-1.5zM0 6V4.5h-1.5V6H0zm0 2h-1.5v1.5H0V8zm7.985 0h1.5V6.5h-1.5V8zm0 6h-1.5v1.5h1.5V14zm2 0v1.5h1.5V14h-1.5zm0-6V6.5h-1.5V8h1.5zM18 8v1.5h1.5V8H18zm0-2h1.5V4.5H18V6zM9.985 6h-1.5v1.5h1.5V6zm-2-4.5h2v-3h-2v3zm1.5 4.5V0h-3v6h3zM0 7.5h7.985v-3H0v3zm1.5.5V6h-3v2h3zm6.485-1.5H0v3h7.985v-3zm1.5 7.5V8h-3v6h3zm.5-1.5h-2v3h2v-3zM8.485 8v6h3V8h-3zM18 6.5H9.985v3H18v-3zM16.5 6v2h3V6h-3zM9.985 7.5H18v-3H9.985v3zM8.485 0v6h3V0h-3z",
      fill: "#F7FCFF",
      mask: "url(#AI_svg__e)"
    }
  ))))
);
export {
  t as default
};
